// src/layouts/AuthLayout.js
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

// Este layout tiene Navbar y Footer, PERO NO tiene padding superior.
function AuthLayout({ children }) {
    return (
        <>
            <Navbar />
            <main className="pt-20">
                {children}
            </main>
            <Footer />
        </>
    );
}

export default AuthLayout;
